import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetStudyResearchers } from 'src/api/studies-queries';

export function StudiesResearchersTable() {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { studyId } = useParams();

  const { data, isLoading } = useGetStudyResearchers(studyId ?? '');

  const researchers = useMemo(() => data?.researchers ?? [], [data]);

  const headers = [
    { label: 'First name', key: 'firstName' },
    { label: 'Last name', key: 'lastName' },
    { label: 'Email', key: 'email' },
    { label: 'Roles', key: 'roles' },
  ];

  const transformedData = useMemo(
    () =>
      researchers
        .filter(
          (researcher) =>
            researcher.researcherGivenName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            researcher.researcherFamilyName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((researcher) => ({
          id: researcher.userId,
          firstName: researcher.researcherGivenName,
          lastName: researcher.researcherFamilyName,
          email: researcher.researcherEmail,
          role: researcher.isManager ? 'Admin' : 'Researcher',
        })) ?? [],
    [researchers, searchTerm],
  );

  return (
    <section className="flex flex-col w-full mt-12 border border-stroke-on-dark-subdued rounded-lg bg-background-dark-subdued px-4 py-6">
      <TableV2
        headers={headers}
        data={transformedData}
        searchPlaceholder="Search by name or email"
        onSearch={(t) => setSearchTerm(t)}
        isLoading={isLoading}
      />
    </section>
  );
}
